import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'remains-to-deliver-client',
  templateUrl: './templates/remains-to-deliver-client.component.html',
  styleUrls: ['./styles/remains-to-deliver-client.component.css']
})
export class RemainsToDeliverClientComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/remains-to-deliver-client.component.ts